export const authApiURL = {
  login: "/auth/login",
};
